import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { useInView } from 'react-intersection-observer';
import "../../css/Cashless.css";

const Cashless = ({ theme = 'ltm' }) => {
    const { ref: tituloRef, inView: tituloInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: textRef, inView: textInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: imageRef, inView: imageInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: subtextRef, inView: subtextInView } = useInView({ threshold: 0.1, triggerOnce: true });


    return (
        <div id="cashless" className={`${theme}-fondo-crema pb-1`}>
            <h1 ref={tituloRef} className={`${theme}-titulo-club pt-4 pb-md-5 mb-3 text-center ${tituloInView ? 'cashless-animate-in-bottom' : ''}`}>NUESTRA TARJETA CASHLESS</h1>
            <div className={`${theme}-container-cashless pb-3`}>
                <Row>
                    <Col
                        md={6}
                        ref={textRef}
                        className={`cashless-transition-element ${textInView ? 'cashless-animate-in-left' : ''}`}
                    >
                        <div className='px-4'>
                            <img
                                src="/imagenes/Fotos/foto 8 web - tarjeta cashless.jpg"
                                alt="Tarjeta cashless."
                                className="img-fluid d-md-none mb-4"
                            />
                        </div>
                        <h1 className='mx-4 mx-md-5' style={{ color: "blue" }}>
                            Con esta tarjeta no necesitás efectivo!
                        </h1>
                        <h1 className='mx-4 mx-md-5' style={{ color: "blue" }}>
                            <strong>Fidelizate</strong> para obtener más BENEFICIOS
                        </h1>
                        <h4 className='mx-4 mx-md-5' style={{ color: "blue" }}>
                            La usás, sumás puntos y accedés a promos exclusivas, convenios y sorpresas.
                        </h4>

                        <div className="beneficios-container mt-5 mx-2">
                            <Row className="mb-3 align-items-center">
                                <Col xs={2} className="text-end">
                                    <i className="bi bi-star-fill text-primary"></i>
                                </Col>
                                <Col xs={10}>
                                    <h5 className="mb-1">Sumá puntos</h5>
                                    <p>cada vez que te conectás a un slot.</p>
                                </Col>
                            </Row>

                            <Row className="mb-3 align-items-center">
                                <Col xs={2} className="text-end">
                                    <i className="bi bi-gift text-primary"></i>
                                </Col>
                                <Col xs={10}>
                                    <h5 className="mb-1">Canjeá</h5>
                                    <p>por cupones para participar de las promos.</p>
                                </Col>
                            </Row>

                            <Row className="mb-3 align-items-center">
                                <Col xs={2} className="text-end">
                                    <i className="bi bi-coin text-primary"></i>
                                </Col>
                                <Col xs={10}>
                                    <h5 className="mb-1">Disfrutá</h5>
                                    <p>de nuestro estacionamiento exclusivo, premios y más beneficios.</p>
                                </Col>
                            </Row>
                        </div>
                    </Col>

                    <Col
                        md={6}
                        className={`px-5 pb-4 pb-md-1 d-none d-md-inline-block cashless-transition-element ${imageInView ? 'cashless-animate-in-right' : ''} `}
                        ref={imageRef}
                    >
                        <img
                            src="/imagenes/Fotos/foto 8 web - tarjeta cashless.jpg"
                            alt="Tarjeta Cashless"
                            className="img-fluid"
                            style={{ objectFit: 'cover', height: '100%' }}
                        />
                    </Col>
                </Row>
            </div>
            <h4
                className={`${theme}-piedepagina-cashless mx-4 mx-md-5 pt-md-4 pb-4 ${subtextInView ? 'cashless-animate-in-bottom' : ''}`}
                ref={subtextRef}
                style={{ color: "blue" }}
            >
                ¿Querés una tarjeta anónima? Podés ganar y devolver tu tarjeta al finalizar tu visita
            </h4>
        </div>
    );
};

export default Cashless;
